import React from 'react';
import { X } from 'lucide-react';
const painPoints = [<>
    <strong className="font-bold" data-id="element-143">Llegás agotada</strong> del trabajo y no tenés
    ganas de cocinar.
  </>, <>
    Terminás pidiendo delivery aunque sabés que estás{' '}
    <strong className="font-bold" data-id="element-144">gastando de más.</strong>
  </>, <>
    Abrís la heladera y{' '}
    <strong className="font-bold" data-id="element-145">no sabés qué preparar.</strong>
  </>, <>
    Cocinás algo rápido y volvés a{' '}
    <strong className="font-bold" data-id="element-146">lavar una montaña de platos.</strong>
  </>, <>
    <strong className="font-bold" data-id="element-147">Siempre comés lo mismo</strong> y te aburrís.
  </>, <>
    <strong className="font-bold" data-id="element-148">Tirás comida</strong> porque se echó a perder.
  </>, <>
    Te prometés organizarte… y{' '}
    <strong className="font-bold" data-id="element-149">nunca pasa.</strong>
  </>];
export function PainPointsSection() {
  return <section className="py-5 md:py-7 px-4 bg-[#F7F5F0] text-text-primary" data-id="element-150">
      <div className="max-w-2xl mx-auto" data-id="element-151">
        <h2 className="text-xl md:text-3xl text-center mb-4 md:mb-5 font-bold tracking-tight text-text-primary" data-id="element-152">
          Esto es exactamente lo que te está pasando…
        </h2>

        <div className="space-y-2 md:space-y-2.5" data-id="element-153">
          {painPoints.map((point, i) => <div key={i} className="bg-white rounded-2xl border-l-4 border-danger px-3 py-2 md:px-4 md:py-3 flex items-start gap-3 md:gap-4 shadow-sm" data-id="element-154">
              <X className="text-danger flex-shrink-0 mt-0.5" size={16} strokeWidth={3} data-id="element-155" />
              <p className="text-xs md:text-sm text-text-primary/90 leading-relaxed font-medium" data-id="element-156">
                {point}
              </p>
            </div>)}
        </div>

        <p className="text-sm md:text-lg font-bold text-center mt-5 md:mt-6 text-text-primary" data-id="element-157">
          No es falta de voluntad.{' '}
          <span className="text-danger" data-id="element-158">
            Es que nadie te enseñó un sistema.
          </span>
        </p>
      </div>
    </section>;
}